import React from 'react';
import { campaignService } from '../services/campaignService';
import CampaignForm from '../components/campaign/CampaignForm';

const CreateCampaign = () => (
  <CampaignForm
    mode="create"
    onSubmit={(payload) => campaignService.createCampaign(payload)}
  />
);

export default CreateCampaign;
